// Static client-only data (cities, conditions, currencies). All dynamic content comes from backend.
export const CITIES = [
  "București", "Cluj-Napoca", "Timișoara", "Iași", "Constanța",
  "Brașov", "Craiova", "Galați", "Oradea", "Sibiu",
  "Ploiești", "Bacău", "Pitești", "Arad", "Târgu Mureș",
];
export const CONDITIONS = ["Nou", "Ca nou", "Folosit"];
export const CURRENCIES = ["lei", "EUR"];

export const DEFAULT_THEME = {
  name: "AMD Dark",
  primary: "#ED1C24", primaryHover: "#C8161D",
  background: "#0A0A0A", surface: "#141414", surfaceAlt: "#1C1C1C",
  border: "#262626", text: "#F5F5F5", textMuted: "#A1A1A1",
  accent: "#ED1C24", headerBg: "#000000",
};

export const PRESET_THEMES = [
  { name: "AMD Dark", primary: "#ED1C24", primaryHover: "#C8161D", background: "#0A0A0A", surface: "#141414", surfaceAlt: "#1C1C1C", border: "#262626", text: "#F5F5F5", textMuted: "#A1A1A1", accent: "#ED1C24", headerBg: "#000000" },
  { name: "OLX Light", primary: "#002F34", primaryHover: "#004852", background: "#F2F4F5", surface: "#FFFFFF", surfaceAlt: "#F8F9FA", border: "#E4E5E7", text: "#0A2D34", textMuted: "#6B7280", accent: "#23E5DB", headerBg: "#FFFFFF" },
  { name: "Midnight Blue", primary: "#3B82F6", primaryHover: "#2563EB", background: "#0B1220", surface: "#111827", surfaceAlt: "#1F2937", border: "#1F2937", text: "#F1F5F9", textMuted: "#94A3B8", accent: "#60A5FA", headerBg: "#020617" },
  { name: "Forest", primary: "#16A34A", primaryHover: "#15803D", background: "#0B1410", surface: "#14201A", surfaceAlt: "#1B2A22", border: "#1F3329", text: "#ECFDF5", textMuted: "#9CA3AF", accent: "#22C55E", headerBg: "#06120D" },
];
